<template>
  <div class="iso-page container-md">
    <div class="iso-title">国际标准ISO27001信息安全管理体系认证</div>
    <div class="iso-image">
      <div class="iso-img-cn">
        <img src="../assets/imgs/homepage/iso-cn.jpg" alt="">
      </div>
      <div class="iso-img-en">
         <img src="../assets/imgs/homepage/iso-en.jpg" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'iso-auth',

};
</script>
<style lang="less" scoped>
.iso-page{
  margin: 40px auto;
  background: #fff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.06);
  border-radius: 2px;
  padding-top: 48px;
  .iso-title{
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .iso-image{
    display: flex;
    padding: 0 50px;
    .iso-img-cn, .iso-img-en{
      width: 50%;
      img{
        width: 100%;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/ISOAuth.vue